import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const nullableHomeownersAssociationFeeSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphData => get(graphData, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.MonthlyHoa`, null),
);

export const hasHomeownerAssociationFeeSelector = createSelector(
  nullableHomeownersAssociationFeeSelector,
  nullableHomeownersAssociationFee =>
    nullableHomeownersAssociationFee !== null && nullableHomeownersAssociationFee !== 0,
);

export default nullableHomeownersAssociationFeeSelector;
